export default class Room {
  id: string
  name: string
  constructor (id: string, displayName: string) {
    this.id = id
    this.name = displayName
  }
}
